import * as React from 'react'
import * as st from './title.module.scss'
import { MakeUrl } from '../../selectors/requestContext'
import { detailPagePath } from '../../utils/url'
import * as utilityClasses from '../utilityClasses.module.scss'
import { AtfTreatmentProps } from '../../reducers/features'
import * as cn from 'classnames'
import { isTreatment } from '../../utils/utils'
import { ResponsiveImage } from '../images/responsiveImage'
import { SrcSize, SrcType } from '../../utils/imageUtils'

export interface ITitleProps extends AtfTreatmentProps {
  title?: string
  asin?: string
  cGti?: string
  showLinkToDP?: boolean
  makeUrl?: MakeUrl
  isRetail?: boolean
  titleLogo?: string
  providerLogo?: string
}

const TITLE_DESKTOP_WIDTH = 600
const TITLE_MOBILE_WIDTH = 300
const PROVIDER_DESKTOP_WIDTH = 300
const PROVIDER_MOBILE_WIDTH = 200

export const Title = ({ title, asin, cGti, isRetail, makeUrl, showLinkToDP = false, atfTreatment, titleLogo, providerLogo}: ITitleProps) => {
  const decoratedTitle = titleArt(providerLogo, titleLogo, title) || (title && <h1 className={cn(utilityClasses.fullWidth, st.title, {[st.textShadow]: isTreatment(atfTreatment, 'T1', 'T2', 'T3')})}
                                      data-automation-id="title">{title}</h1>)
  if (!decoratedTitle) {
    return null
  } else if (showLinkToDP) {
    const titleId = isRetail ? asin || cGti : cGti
    const url = makeUrl && titleId && makeUrl(detailPagePath(titleId), {refTag: 'atv_hover_title'})
    return <a href={url}>{decoratedTitle}</a>
  } else {
    return decoratedTitle
  }
}


const titleArt = (providerLogo: string, titleLogo: string, title: string) => {

  const titleImgProps = {
    alt: title,
    src: titleLogo,
    baseValue: TITLE_DESKTOP_WIDTH,
    srcSizes: [
      { 'max-phablet': TITLE_MOBILE_WIDTH },
      { 'min-phablet': TITLE_DESKTOP_WIDTH },
    ] as SrcSize[],
    format: SrcType.png
  }

  return titleLogo && (
    <>
      { provider(providerLogo) }
      <div className={cn(utilityClasses.fullWidth, st.titleLogoContainer)}>
        <div className={st.titleLogoBorder}>
          <ResponsiveImage className={st.titleLogo}  {...titleImgProps} />
        </div>
      </div>
    </>
  )

}

const provider = (providerLogo: string) => {

  const providerImgProps = {
    alt: '',
    src: providerLogo,
    baseValue: PROVIDER_DESKTOP_WIDTH,
    srcSizes: [
      { 'max-phablet': PROVIDER_MOBILE_WIDTH },
      { 'min-phablet': PROVIDER_DESKTOP_WIDTH },
    ] as SrcSize[],
    format: SrcType.png
  }

  return providerLogo && (
    <div className={cn(utilityClasses.fullWidth, st.providerLogoContainer)}>
      <ResponsiveImage className={st.providerLogo} {...providerImgProps} />
    </div>
  )

}